import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";

import { CustomInput } from "src/component";
import { renderAlert } from "src/utils/functions";
import { createAppliance, updateAppliance } from "src/services/api";

const CreateAppliances = ({
    editData,
    refetch,
    setModalOpen,
}) => {


    const initialValues = {
        name: editData?.name ?? "",
        minRating: editData?.minRating ?? "",
        maxRating: editData?.maxRating ?? "",
    };

    const validationSchema = yup.object().shape({
        name: yup.string().required("appliance name is required"),
        minRating: yup.string().matches(/^\d+$/, "Minimum Rating must be a valid number").required("Minimum Rating is required"),
        maxRating: yup.string().matches(/^\d+$/, "Maximum Rating  must be a valid number").required("Maximum Rating is required"),
    });

    const { mutate, isLoading } = useMutation(editData ? updateAppliance : createAppliance, {
        onSuccess: (res) => {
            renderAlert({
                title: "Success",
                msg: res?.msg,
                type: "success",
            }).then((result) => {

                if (result) {
                    setModalOpen(false);
                } else {
                    setModalOpen(false);
                }
            });
            refetch();

        },
    });


    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {

                    if (editData) {

                        let data = {
                            maxRating: values?.maxRating,
                            minRating: values?.minRating,
                            name: values?.name,
                            id: editData?.id
                        }
                        mutate(data);
                    } else {
                        let data = {
                            maxRating: values?.maxRating,
                            minRating: values?.minRating,
                            name: values?.name,
                        }
                        mutate(data);
                    }

                }}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="px-[3rem] py-[2rem]">


                            <CustomInput
                                title="Name"
                                name="name"
                                placeholder="Enter Name"
                                onChange={handleChange}
                                value={values.name}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                            />
                            <CustomInput
                                title="Minimum Rating"
                                name="minRating"
                                placeholder="Enter Min Rating"
                                onChange={handleChange}
                                value={values.minRating}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                            />
                            <CustomInput
                                title="Maximum Rating"
                                name="maxRating"
                                placeholder="Enter Max Rating"
                                onChange={handleChange}
                                value={values.maxRating}
                                onBlur={handleBlur}
                                formType="fill"
                                isRequired={true}
                            />

                        </div>

                        <div className="border-t border-t-gray">
                            <div className="flex justify-end px-[3rem] py-[2rem]">
                                <button
                                    disabled={isLoading}
                                    type="submit"
                                    className="btn-loader flex justify-center bg-lightPrimary items-center rounded-[5px]  text-defaultPrimary py-[2rem] px-[4rem] h-[3.5rem]"
                                >
                                    {editData ? "Update" : "Create"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default CreateAppliances;
